import { useQuery } from "@tanstack/react-query";
import { getTeams, getTeam } from "@/lib/teams-api";
import { useOrgId } from "@/lib/org-context";

export function useTeams(params?: { search?: string; page?: number; perPage?: number }) {
  const { search, page, perPage } = params ?? {};
  const orgId = useOrgId();

  const { data, isPending } = useQuery({
    queryKey: ["teams", orgId, { search, page, perPage }],
    queryFn: () => getTeams({ search, page, perPage }),
    enabled: !!orgId,
    staleTime: 30_000,
  });

  return {
    teams: data?.data ?? [],
    pagination: data?.pagination ?? null,
    isPending,
  };
}

export function useTeam(teamId: string | undefined) {
  const orgId = useOrgId();

  const { data, isPending } = useQuery({
    queryKey: ["team", orgId, teamId],
    queryFn: () => getTeam(teamId!),
    enabled: !!orgId && !!teamId,
    staleTime: 30_000,
  });

  return { team: data ?? null, isPending };
}
